var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconPresent48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_20894)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6545 7.50293C19.792 7.50293 23.8285 15.5599 23.8285 15.5599V19.1932C23.5277 19.1932 23.2358 19.1905 22.9473 19.1868C11.2458 19.0369 9.46767 15.8924 9.19802 13.9819C9.15807 13.697 9.15124 13.4396 9.15011 13.2238L9.1499 13.0699C9.1499 11.4926 9.51674 7.50293 14.6545 7.50293ZM24.6495 19.1914L24.2041 19.1932V15.5599C24.2041 15.5599 24.2271 15.514 24.2718 15.4291L24.3551 15.2735C25.1323 13.8389 28.8226 7.50293 33.3781 7.50293C38.5159 7.50293 38.8828 11.4926 38.8828 13.0699L38.8826 13.2238C38.8816 13.4396 38.8749 13.697 38.8345 13.9818C38.5654 15.8924 36.7869 19.0369 25.0856 19.1869L24.6495 19.1914Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1733 16.3891C28.1733 18.7362 26.2705 20.6391 23.9229 20.6391C21.5761 20.6391 19.6733 18.7362 19.6733 16.3891C19.6733 14.0421 21.5761 12.1392 23.9229 12.1392C26.2705 12.1392 28.1733 14.0421 28.1733 16.3891Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.54308 22.5029H39.4569C40.3091 22.5029 41 21.8324 41 21.0052V18.0006C41 17.1735 40.3091 16.5029 39.4569 16.5029H8.54308C7.69086 16.5029 7 17.1735 7 18.0006V21.0052C7 21.8324 7.69086 22.5029 8.54308 22.5029Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4977 41.5029H37.5023C38.3295 41.5029 39 40.7951 39 39.922V22.5029H9V39.922C9 40.7951 9.67054 41.5029 10.4977 41.5029Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 34.8022L20.9261 36.5011C20.9188 36.5052 20.9097 36.5022 20.9058 36.4945C20.9043 36.4914 20.9037 36.4879 20.9043 36.4844L21.4914 32.886L19.0045 30.3377C18.9986 30.3316 18.9985 30.3215 19.0043 30.3153C19.0066 30.3128 19.0096 30.3112 19.0129 30.3107L22.4496 29.7857L23.9865 26.5118C23.9902 26.5039 23.9992 26.5007 24.0067 26.5046C24.0096 26.5061 24.012 26.5086 24.0135 26.5118L25.5504 29.7857L28.9871 30.3107C28.9953 30.3119 29.001 30.32 28.9998 30.3286C28.9994 30.332 28.9978 30.3352 28.9955 30.3377L26.5086 32.886L27.0957 36.4844C27.0971 36.493 27.0916 36.5012 27.0834 36.5027C27.0801 36.5033 27.0768 36.5027 27.0739 36.5011L24 34.8022Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_20894"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconPresent48);
export default __webpack_public_path__ + "static/media/pictogramBeaconPresent48.0031e0aa64661c2891d06cf4463a8bb8.svg";
export { ForwardRef as ReactComponent };